// src/components/Shelf.js

import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import Book from "./Book";

// Create functional component
const Shelf = ({ books, title, updateBookShelf }) => {
    return (
        <div className="bookshelf">
            <h2 className="bookshelf-title">{title}</h2>
            <div className="bookshelf-books">
                <ol className="books-grid">
                    {
                        // Define MAP function to loop thru books object array
                        books.map((b) => (
                            // Code Functionality Requirement 3: using key for list item
                            <li key={b.id}>
                                <Book book={b} changeBookShelf={updateBookShelf} />
                            </li>
                        ))
                    }
                </ol>
            </div>
        </div>
    );
};

// Add PropTypes for validation
Shelf.propTypes = {
    books: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    updateBookShelf: PropTypes.func.isRequired,
};

export default Shelf;
